module.exports = __webpack_public_path__ + "img/ywyk-instructions05.48ce8cb4.jpg";